<main class="pagination-container">
  <section class="left-section">
    <span class="page-selector--text">
      Showing {{ pageInfo.firstElementIndex }} -
      {{ pageInfo.lastElementIndex }} of {{ pageInfo.totalElements }} items
    </span>
  </section>
  <section class="right-section">
    <sl-button
      type="icon-only"
      variant="tertiary"
      iconName="chevron_left"
      [disabled]="!pageInfo.hasPrevious"
      (clickEvent)="changePage('back')"
    ></sl-button>
    <span class="page-selector--text">
      {{ pageInfo.currentPage }} / {{ pageInfo.totalPages }}
    </span>
    <sl-button
      variant="tertiary"
      type="icon-only"
      iconName="chevron_right"
      [disabled]="!pageInfo.hasNext"
      (clickEvent)="changePage('next')"
    ></sl-button>
  </section>
</main>
